export default __webpack_public_path__ + "static/sprints-third-image-22431c97591a5feb3f34de4b24c7be0b.jpg";